/**
 * What an external guest is told before joining: Felix transcribes the meeting.
 *
 * Row cd7ca6c9 (founder, #3616 comment 5938037325): "Today a guest is
 * transcribed without ever being told." The join screen shows these words
 * before the Join button, and pressing Join is the acceptance: guest-auth
 * stores WHICH version the guest saw, and refuses a join that does not carry
 * the current one.
 *
 * Mirrors app/services/guest_transcription_consent.py (NOTICE_TEXT,
 * ACCEPTANCE_TEXT, GUEST_TRANSCRIPTION_NOTICE_VERSION); a backend test pins the
 * two equal. Change the words, change the version: the stored version must name
 * the words the guest actually saw. The wording is on counsel's go-live review
 * list (docs/GO_LIVE_FOUNDER_ACTIONS.md, section B).
 */

export const GUEST_TRANSCRIPTION_NOTICE_VERSION = "transcription-v1";

export const GUEST_TRANSCRIPTION_NOTICE =
  "Felix, FTL's AI assistant, transcribes this meeting.";

export const GUEST_TRANSCRIPTION_ACCEPTANCE =
  "By joining you agree that what you say and type in this meeting is transcribed.";

/** Where the version the guest accepted is kept for the mid-meeting re-auths
 *  (the 90-minute LiveKit refresh and the 401 retry): they call guest-auth
 *  again and must carry the acceptance the guest gave on the join screen. */
export const GUEST_ACCEPTED_NOTICE_KEY = "ftl_guest_accepted_notice_version";
